import Textarea from '@/components/form/Textarea';

const WorkExperienceField = () => {
  return (
    <Textarea name="workExperience" label="Work Experience" height={200} />
  );
};

export default WorkExperienceField;
